import api from '../utils/api';
import { getAuthHeaders } from '../context/auth/Auth';

export const getAllCertifications = async (): Promise<any> => {
    return await api.get('/certifications?_limit=-1',
        { headers: { ...getAuthHeaders() }, params: {}}
    ).then((response) => response.data);
};